module.exports = __webpack_public_path__ + "static/media/02b.64c8a489.jpg";